import React from 'react';

export default function FacebookLogo({fill}) {
  return (
    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M29 14.5883C29 6.53058 22.509 0 14.5 0C6.49105 0 0 6.53058 0 14.5883C0 21.8711 5.30156 27.9059 12.2344 29V18.8053H8.5527V14.5883H12.2344V11.3743C12.2344 7.71868 14.3981 5.69856 17.7115 5.69856C19.2974 5.69856 20.957 5.98349 20.957 5.98349V9.57359H19.1276C17.3264 9.57359 16.7656 10.6991 16.7656 11.853V14.5883H20.7871L20.1442 18.8053H16.7656V29C23.6984 27.9059 29 21.8711 29 14.5883Z" fill={fill} />
    </svg>
  );
}
